import { render, staticRenderFns } from "./default.vue?vue&type=template&id=215238b6&scoped=true&lang=pug"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=215238b6&prod&lang=stylus"
import style1 from "./default.vue?vue&type=style&index=1&id=215238b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215238b6",
  null
  
)

export default component.exports